import React from 'react';
import PropTypes from 'prop-types';

import CartIcon from '../../../../../../components/icons/CartIcon';
import Button from '../../../../../../components/global/Button';
import DismissButton from '../../../../../../components/global/DismissButton';

const propTypes = {
  onCheckout: PropTypes.func.isRequired,
  onMakeAnother: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
const AccountCardAddToCartSuccess = ({
  onCheckout,
  onMakeAnother,
  onClose,
}) => {
  return (
    <div className="account-card-add-to-cart">
      <div className="card-element-control-header-dismiss">
        <DismissButton onClick={() => onClose()} />
      </div>
      <div className="text-center mt-2">
        <CartIcon
          id="account-card-checkout"
          size={36}
          color="#0d84fe"
          className="mb-2"
        />
      </div>
      <h4 className="text-center mb-2">
        Your Waldogram has been added to your cart!
      </h4>
      <Button
        onClick={onCheckout}
        className="d-flex align-items-center"
        btnBlock
      >
        <CartIcon id="account-card-checkout-2" color="#fff" className="mr-1" />{' '}
        Check out now
      </Button>
      <Button onClick={onMakeAnother} btnBlock btnOutline>
        Make another
      </Button>
    </div>
  );
};

AccountCardAddToCartSuccess.propTypes = propTypes;

export default AccountCardAddToCartSuccess;
